import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import NavigationBar from '@/components/NavigationBar';

const ComingSoon = ({ title, user }) => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#FFFBF5' }}>
      <NavigationBar user={user} />
      
      <div className="flex items-center justify-center px-6" style={{ minHeight: 'calc(100vh - 80px)' }}>
        <div className="text-center max-w-2xl">
          <h1 className="text-5xl font-bold mb-6">{title}</h1>
          <p className="text-xl text-gray mb-8">
            This exclusive offering is coming soon. Register your interest to be the first to know when it launches.
          </p>
          <div className="flex gap-4 justify-center">
            <Link to="/register-interest">
              <Button className="bg-white text-gold hover:bg-white/90 px-8 py-6 shadow-lg">Register Interest</Button>
            </Link>
            <Link to="/">
              <Button className="bg-black text-white hover:bg-black/90 px-8 py-6 shadow-lg">Back to Home</Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
